<template>
  <ElDialog
    :title="$t('FINANCE.SALES_CHART.FILTER')"
    :visible="value"
    width="30%"
    @close="emitInputEvent"
  >
    <ElForm>
      <ElFormItem>
        <ElRadioGroup :value="chartMode" @input="updateChartMode">
          <ElRadioButton label="disaggregated">
            {{ $t(getChartModeLabel('disaggregated')) }}
          </ElRadioButton>
          <ElRadioButton label="total">
            {{ $t(getChartModeLabel('total')) }}
          </ElRadioButton>
        </ElRadioGroup>
      </ElFormItem>

      <ElFormItem :label="$t('FROM_DATE')">
        <UiDatePicker
          :default-date="lastWeekDate"
          @select-date="emitFromDateEvent"
        />
      </ElFormItem>

      <ElFormItem :label="$t('TO_DATE')">
        <UiDatePicker
          :default-date="currentDate"
          @select-date="emitToDateEvent"
        />
      </ElFormItem>
      <ElButton type="primary" @click.native.prevent="$emit('updateFilter')">
        {{ $t('APPLY') }}
      </ElButton>
      <ElButton
        type="text"
        :plain="true"
        @click.native.prevent="emitInputEvent"
      >
        {{ $t('CANCEL') }}
      </ElButton>
    </ElForm>
  </ElDialog>
</template>

<script>
import UiDatePicker from '@@/layout/UiDatePicker';
import getChartModeLabel from '@/utils/finance/salesChartModeTranslation';

export default {
  name: 'SalesChartFilterModal',
  components: {
    UiDatePicker,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartMode: 'disaggregated',
    };
  },
  computed: {
    currentDate() {
      return Date.now();
    },
    lastWeekDate() {
      const date = new Date();

      return date.setDate(date.getDate() - 7);
    },
  },
  methods: {
    getChartModeLabel,
    emitInputEvent() {
      this.$emit('input', false);
    },
    emitFromDateEvent(date) {
      this.$emit('fromDateChange', date);
    },
    emitToDateEvent(date) {
      this.$emit('toDateChange', date);
    },
    updateChartMode(mode) {
      this.chartMode = mode;
      this.$emit('chartModeChange', mode);
    },
  },
};
</script>

<style></style>
